import { injectGlobal } from '@emotion/css';
import { mqBreakpoints } from '../constants/media-query-breakpoints';

injectGlobal({
  html: {
    fontSize: '4.26667vw',
  },

  [mqBreakpoints.tablet]: {
    html: {
      fontSize: '2.08333vw',
    },
  },

  [mqBreakpoints.desktop]: {
    html: {
      fontSize: '1.11111vw',
    },
  },

  [mqBreakpoints.maxDesktop]: {
    html: {
      fontSize: '100%',
    },
  },
});
